/* eslint-disable no-plusplus */ /* eslint-disable no-bitwise */ var hash = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var content = JSON.stringify(args);
    var hashValue = 0;
    for(var i = 0, chr; i < content.length; i++){
        chr = content.charCodeAt(i);
        hashValue = (hashValue << 5) - hashValue + chr;
        hashValue |= 0; // Convert to 32bit integer
    }
    return hashValue;
};
export default hash;

//# sourceMappingURL=hash.js.map